<template>
  <div>
    <slot />
    <Footer />
    <div id="overlay">
      <font-awesome-icon class="loading-icon" icon="spinner" size="2x" pulse />
    </div>
  </div>
</template>

<script>
import Footer from "@/layouts/Footer";

export default {
  name: "App",
  components: {
    Footer
  }
};
</script>


// WEBPACK FOOTER //
// src/layouts/Login.vue